import { FeedMode } from '@/types/models/Term.model'
import { Department } from '@/domain/department/department'
import { CoOccurringDisorder } from '@/domain/primaryFocus/constant'

interface GetCoOccurringDisorderLabelByDepartmentAndFeedModeParams {
  coOccurringDisorder: string
  termFeedMode: FeedMode
  department: Department
}

export function getCoOccurringDisorderLabelByDepartmentAndFeedMode({
  coOccurringDisorder,
  termFeedMode,
  department
}: GetCoOccurringDisorderLabelByDepartmentAndFeedModeParams): string {
  if (
    termFeedMode === FeedMode.PRIMARY_FOCUS_STRICT &&
    department === Department.MentalHealth &&
    coOccurringDisorder === CoOccurringDisorder.SUBSTANCE_USE
  ) {
    return 'Co-Occurring Disorders'
  }

  return coOccurringDisorder
}
